// extracted by mini-css-extract-plugin
export default {"wrapper":"menuAddSearchListItem_wrapper__OBVvn","imageWrapper":"menuAddSearchListItem_imageWrapper__1q+YY","addWrapper":"menuAddSearchListItem_addWrapper__oLvkj"};